<template>
  <div class="text-container">
    <div class="title">ix cam 기술 개인 정보 보호 정책</div>
    <div class="text">
      당사의 개인정보 보호정책은 2024년 5월 16일에 업데이트되었으며 2024년 5월 17일부터 시행됩니다. 당사는 별도의 개인정보 보호정책을 제외하고, 모든 ix cam 제품 및 서비스와 현재 제공되는 특정 ix cam 제품 또는 서비스를 사용할 때 귀하가 공개하는 개인정보를 당사가 어떻게 관리하는지에 대한 개인정보 보호 세부정보를 제공하기 위해 개인정보 보호정책을 개정했습니다.
    </div>
    <div class="text">
      시간을 내어 당사의 개인정보 보호관행을 숙지하고 질문이 있는 경우 알려주시기 바랍니다.
    </div>
    <div class="title">우리는 당신에게 약속합니다</div>
    <div class="text">
      이 개인 정보 보호 정책은 Guangzhou Qiangui IoT Technology Co., Ltd. 및 그 계열사(이하 " ix cam " 또는 "당사")가 ix cam APP 정보 당사 제품 및 서비스를 사용할 때 귀하의 신원을 확인하기 위해 특정 정보를 제공하도록 요청하는 경우 이 개인정보 보호정책 및/또는 사용자 이용약관에 따라 이 정보를 엄격하게 사용합니다.
    </div>
    <div class="text">
      이 개인 정보 보호 정책은 귀하의 필요를 염두에 두고 개발되었으며 귀하가 당사의 개인 데이터 수집 및 사용 관행을 완전히 이해하고 당사에 제공된 모든 개인 정보를 궁극적으로 제어하는 것이 중요합니다.
    </div>
    <div class="text">
      이 개인 정보 보호 정책에서 "개인 정보"는 해당 개인에 대한 정보를 통해 또는 당사가 액세스할 수 있는 해당 개인에 대한 다른 정보와 결합하여 특정 개인을 직간접적으로 식별할 수 있는 모든 데이터를 의미합니다. 이러한 개인 정보에는 다음이 포함되지만, 귀하가 제공하거나 업로드하는 정보 및 기기 정보에 국한되지 않음
    </div>
    <div class="text">
      당사 제품 및 서비스를 사용하거나 사용법을 준수함으로써 귀하는 정기적으로 변경하는 사항을 포함하여 이 개인정보 보호정책에 설명된 모든 조건을 읽고 수락했음을 나타냅니다. 현지 데이터를 포함한 사용법을 준수하기 위해 보호법(예: 유럽 연합의 포괄적인 데이터 보호 규정)에 따라 당사는 특정 범주의 개인 데이터 처리(예: 자동화된 개인 의사 결정)에 대해 귀하의 명시적 동의를 구할 것입니다. 현지 데이터 보호법을 포함하여 해당 법률을 준수하는 귀하의 개인 정보 보안 동시에 우리 는 모든 직원과 대리인이 이러한 의무를 충족할 수 있도록 최선을 다하고 있습니다. 
    </div>
    <div class="text">
      결국 우리가 원하는 것은 사용자에게 최고의 경험을 제공하는 것입니다. 이 개인 정보 보호 정책에 설명된 데이터 처리 관행에 대해 질문이 있는 경우 FAE@naxclow.com으로 문의하여 귀하의 요구 사항을 해결하고 귀하의 질문에 직접 답변해 드리겠습니다.
    </div>
    <div class="title">一、어떤 정보를 수집하고 어떻게 사용합니까？</div>
    <div class="subtitle">（一）당사가 귀하의 개인 정보를 수집하고 사용하도록 승인해야 하는 상황</div>
    <div class="text">
      개인 정보를 수집하는 목적은 제품 및/또는 서비스를 제공하고 관련 법률, 규정 및 기타 규범 문서를 준수하도록 하는 것입니다. 귀하는 이 정보 제공 여부를 선택할 권리가 있지만 대부분의 경우, 제공하지 않으면 해당 서비스를 제공하지 못하거나 질문에 응답하지 못할 수 있습니다. 이러한 기능은 다음과 같습니다.：
    </div>
    <div class="numtitle">（1） 스마트 연결</div>
    <div class="text">
       ix cam의 서비스 를 제공 하고 스마트 기기를 안전하게 연결 및 관리할 수 있도록 하기 위해 귀하의 Wi-Fi 정보, IP 주소, 위치 정보, 로그인 계정 정보, 휴대폰 관련 정보, 스마트 기기 관련 정보 정보 를 수집할 수 있습니다. , 출납원 계정 및 스마트 기기 관련 정보 이 정보는 스마트 기기의 빠른 연결, 연결, 주변 기기 검색 및 기기 관리 기능을 제공하는 데 사용됩니다. 위의 정보는 다음과 같이 자세히 설명됩니다. :
    </div>
    <div class="text">• 로그인 계정 정보: 캐셔 계정 번호, 닉네임, 아바타 정보.</div>
    <div class="text">
      • 휴대폰 관련 정보: 하드웨어 장치 식별( imsi , imei , meid , 장치 하드웨어 일련 번호, SIM 카드 식별, OAID , Mac 주소, Android ID), 휴대폰 모델, 시스템 버전 정보, 시스템 언어, 해당 국가 또는 지역 휴대폰 설정, 앱 스토어 버전 번호, 휴대폰 화면 크기 및 해상도, CPU 및 디스플레이 장치 관련 정보.
    </div>
    <div class="text">
      • 스마트 기기 연결 과정에서 수집된 정보 : 연결 해야 하는 스마트 기기의 유형에 따라 다음 정보를 수집할 수 있습니다.：
    </div>
    <div class="text">
      • Wi-Fi로 연결된 스마트 기기: Wi-Fi 정보(SSID, BSSID, Wi-Fi Mac 주소, Wi-Fi 비밀번호), 기기 Mac 주소, 기기 ID
    </div>
    <div class="text">
      • Bluetooth를 통해 로컬 연결을 설정한 후 Wi-Fi를 통해 연결된 스마트 장치: Wi-Fi 정보(SSID, BSSID, Wi-Fi Mac 주소, Wi-Fi 암호), 장치 Mac 주소, 장치 Bluetooth Mac 주소.
    </div>
    <div class="text">• Bluetooth를 통해 연결된 스마트 장치: 장치 Bluetooth Mac 주소, 장치 ID.</div>
    <div class="text">• 메시지 푸시 활성화 후: 응용 프로그램의 앞면과 뒷면에 장치 식별 코드 획득: IMEI, IDFA, Android ID, MAC, OAID, 광고 ID, 일련 번호, IMSI, UAID, ICCID, 설치된 응용 프로그램 정보 또는 실행 중인 프로세스 포함 정보 .</div>
    <div class="numtitle">（2） 기기 공유</div>
    <div class="text">
      지갑 계정, 휴대폰 번호 및 WeChat을 통해 스마트 장치를 다른 사람과 공유할 수 있도록 지원합니다. 공유 후 공유된 사람도 스마트 장치를 제어할 수 있습니다. 이 기능을 즐기기 위해 귀하의 계정 ID, 공유 계정을 수집할 수 있습니다. 귀하가 제공한 ID 및 공유 기기 정보(기기 ID, 기기 이름, 기기 인증 키, 기기 공유 상태), 기기 공유 상태 제공을 위해 사용 다른 캐셔 계정의 사용자가 공통적으로 제어 및 사용하는 기능, 장치 목록 페이지에 공유 상태를 표시하는 데 사용
    </div>
    <div class="numtitle">（3） 애플리케이션 및 지능형 하드웨어 업그레이드：</div>
    <div class="text">
       ix cam 서비스 를 계속 즐길 수 있도록  ix cam 앱 버전 정보 및 휴대폰 모델을 사용하여  ix cam 애플리케이션 업그레이드 서비스를 제공하는 것입니다. 동시에 최신 버전의 서비스(펌웨어 버전 포함)를 사용할 수 있도록 스마트 장치의 업그레이드 기능을 제공하기 위해 연결된 스마트 장치의 목록 및 버전 번호 정보를 수집할 수 있습니다.
    </div>
    <div class="subtitle">
      （二）귀하는 당사가 귀하의 개인 정보를 수집하고 사용하도록 승인할지 여부를 선택할 수 있습니다.
    </div>
    <div class="text">
       ix cam 에서 제공하는 스마트 기기의 제어 및 관리를 보다 원활하게 즐길 수 있도록 다음과 같은 부가 기능이 귀하의 개인 정보를 수집 및 사용할 수 있습니다.이 개인 정보를 제공하지 않으면 Innosilicon의 기본 서비스를 계속 사용할 수 있지만 귀하에게 편의를 제공할 수 있는 이러한 추가 기능을 사용하지 못할 수 있습니다. 이러한 추가 기능은 다음과 같습니다.：
    </div>
    <div class="numtitle">1)움직임 감지 및 식별 관리</div>
    <div class="text">
      이노실리콘 플랫폼 을 통해 동작 감지 및 인식 기능을 지원하는 특정 제품(예: A9)을 연결 했다면 이노 실리콘에서 지원하는 동작 감지 및 인식 기능을 활성화하여 보다 풍부한 스마트 기기 경험을 얻을 수 있습니다. 우리는 귀하의 스마트 장치에서 귀하를 위해 플래그를 지정하고 메시지를 푸시합니다.
    </div>
    <div class="text">
      우리가 식별한 결과에 대해 질문이 있는 경우 알고리즘 및 모델을 최적화하는 데 도움이 되도록 피드백을 제공할 수 있습니다. 이 경우 문제에 대한 요청하지 않은 피드백의 비디오를 수집할 수 있습니다. 피드백하는 비디오는 오직 알고리즘과 모델을 최적화하는 데 사용되며 다른 용도로는 사용되지 않습니다.
    </div>
	<div class="numtitle">（2） 스마트 기기 공유</div>
	<div class="text">
	  지갑 계정과 WeChat을 통해 스마트 기기를 다른 사람과 공유할 수 있도록 지원합니다. 공유 후 공유된 사람도 스마트 장치를 제어할 수 있습니다. 이 기능을 즐기기 위해 귀하의 계정 ID, 귀하가 제공한 공유 계정 ID, 공유 기기 정보(기기 ID, 기기 이름, 기기 인증 키, 기기 공유 상태)를 수집하여 기기 제공에 사용할 수 있습니다. 공유 상태 다른 캐쉬어 계정의 사용자에 대한 공유 제어 및 사용 기능 및 장치 목록 페이지에 표시되는 공유 상태.
	</div>
	<div class="numtitle">（3） 버전 업그레이드</div>
	<div class="text">
	  최신 X 스마트 홈 서비스를 계속 즐길 수 있도록 X 스마트 홈 APP 버전 정보 및 휴대폰 모델을 사용하여 X 스마트 홈 업그레이드 서비스를 제공할 수 있습니다. 동시에 최신 버전의 서비스(펌웨어 버전 포함)를 사용할 수 있도록 스마트 장치의 업그레이드 기능을 제공하기 위해 연결된 스마트 장치의 목록 및 버전 번호 정보를 수집할 수 있습니다.
	</div>
    <div class="numtitle">(4)사용자 피드백</div>
    <div class="text">
      당사는 귀하가 보내주신 피드백 질문, 피드백 로그, 귀하가 입력한 전화번호 또는 이메일을 수집할 수 있습니다. 이러한 정보 는 귀하가 직면한 문제를 더 잘 이해하고 귀하에게 연락하는 데 사용됩니다.
    </div>
    <div class="subtitle">（三） ix cam 권한 호출 안내</div>
    <div class="text">
      또한  ix cam 을 사용할 때 다음과 같은 장치 권한이 트리거될 수 있습니다. 고객님의 정보 를 보다 잘 관리할 수 있도록 상품 이용 과정에서 허가 신청 시 허가의 사용 목적과 허가를 허용하지 않을 경우 서비스 이용에 미칠 수 있는 영향을 알려드립니다. , 잘 확인하시기 바랍니다. 특정 기능을 사용하기 전에 다음 권한에 대한 승인 여부를 선택할 수 있습니다. 동시에 기기 권한 설정 페이지를 통해 언제든지 직접 권한 부여 상태를 변경할 수 있습니다.
    </div>
    <div class="text">다음은 참조를 위한 관련 기능 및 호출 권한에 대한 세부 정보입니다.：</div>
    <div class="text">
      1.외부 저장 공간 읽기 및 쓰기(안드로이드 버전) : 스캔, 사용자 피드백 등의 기능에서 기기의 사진과 파일을 읽고 쓰기 위해 사용합니다.
    </div>
    <div class="text">
      2.위치 권한(Android, iOS 버전): 주변 WLAN 목록 검색, 주변 블루투스 기기 검색, 스마트 씬에서 자동 지오펜싱을 위해 사용되며, 사용자가 gps 를 지원하지 않는 기기에 바인딩된 경우 , 케이던스 계산, 정확한 이동 거리 기록, 사용자의 이동 트랙 그리기 및 기타 기능을 제공하는 데 사용됩니다.
    </div>
    <div class="text">
      3. 카메라 권한(Android, iOS 버전) : 기기 설치, 계정 로그인 및 기타 기능을 위해 QR 코드를 스캔하는 데 사용됩니다.
    </div>
    <div class="text">
      4. 마이크 권한(Android, iOS 버전) : 사용자 가 Innosilicon 에서 카메라, 비디오 초인종 및 기타 장치를 바인딩할 때 비디오 인터콤, 음성 명령 픽업 및 기타 기능에 사용됩니다.
    </div>
    <div class="text">
      5. 전화 권한 읽기(Android): 클라이언트 측에서 로컬로 장치 ID를 생성하는 데 사용됩니다.
    </div>
    <div class="text">
      6. WLAN 권한 활성화(Android, iOS 버전): 장치에 빠른 연결을 위해 사용하는 경우 장치 통신을 위해 장치에서 보낸 WIFI에 연결합니다.
    </div>
    <div class="text">
      7. 블루투스 권한 켜기 (Android, iOS 버전): 장치가 빠르게 연결될 때 장치와 통신하기 위해 장치에서 보낸 블루투스 신호를 연결하는 데 사용되며, 블루투스 를 통해 연결된 스마트 장치 의 경우 블루투스 권한도 통신에 필요 합니다.
    </div>
    <div class="text">
      8. 휴대폰 소프트웨어 설치 목록 가져오기( Android, iOS 버전 ): 편리하고 빠른 로그인을 위해 휴대폰의 타사 계정을 얻는 데 사용됩니다.
    </div>
	<div class="text">
	  9. 하드웨어 장치 식별(imsi, imei, meid, 장치 하드웨어 일련 번호, SIM 카드 식별, OAID, Mac 주소, Android ID), 휴대폰 모델, 시스템 버전 정보 얻기: 경고를 받기 위해 사용자 메시지 푸시
	</div>
	<div class="text">
	  10. 휴대폰 센서 정보 획득(자이로 센서, 중력 센서, 가속도 센서): 광고, 광고 귀속, 부정행위 방지 및 보안에 사용됩니다.
	</div>
	<div style="font-weight: bold;">
	  11. 사진 앨범 권한(Android, iOS 버전): 스캔, 사용자 피드백 등의 기능에서 기기의 사진과 비디오를 읽고 쓰는 데 사용됩니다.
	</div>
	<div style="font-weight: bold;">
	  12. 클립보드(안드로이드, iOS 버전) : 공유 기능을 구현하기 위해 클립보드 기능을 사용합니다.
	</div>
	<div style="font-weight: bold;">
	  13. 기기 정보(IMSI, IDFV) 획득 기기 브랜드, 사업자 정보, 네트워크 정보, 애플리케이션 정보(애플리케이션 이름, 애플리케이션 버전 번호): 원클릭 로그인 기능에 사용됩니다.
	</div>
    <div class="subtitle">
      （四）귀하는 다음과 같은 상황에서 개인정보 수집 및 이용에 대한 귀하의 동의가 필요하지 않음을 충분히 인지하고 있습니다.：
    </div>
    <div class="text">
      당사는 귀하의 이름, 전화번호, 이메일 주소, 은행 계좌 번호 및 IMEI 번호를 사용하여 귀하에게 Guangzhou Qiangui Technology Co., Ltd. 및 그 파트너(웹, 모바일 애플리케이션, 클라우드 제품 및 서비스 제공) 를 제공할 수 있습니다. 제품 및 서비스와 관련된 자료. 당사는 귀하가 거주하는 지역의 데이터 보호법을 엄격히 준수하므로(일부 법률은 별도의 명시적 동의가 필요할 수 있음), 귀하의 사전 명시적 동의만 구하고, 귀하의 동의를 얻었는지 명확한 확인 조치를 통해 확인할 것입니다. 귀하의 개인 정보는 귀하가 동의하거나 반대 의사를 표시할 때까지 사용되지 않습니다. 특정 범주의 이메일을 더 이상 받지 않으려면 페이지 하단에 있는 링크를 클릭하여 이메일 수신을 거부할 수 있습니다. 당사는 직접 마케팅을 위해 귀하의 개인 정보를 비즈니스 파트너에게 전달하지 않습니다.    </div>
    <div class="subtitle">귀하의 정보를 누구와 공유합니까？</div>
    <div class="text">1.국가안보 및 국방안보에 관한 사항；</div>
    <div class="text">2.공공의 안전, 보건 및 주요 공익과 관련된 것；</div>
    <div class="text">3.범죄수사, 기소, 재판 및 판결집행에 관한 사항；</div>
    <div class="text">
      4. 개인정보주체 또는 다른 개인의 생명 및 재산을 보호하기 위하여 있으나 개인의 동의를 얻는 것이 곤란한 경우
    </div>
    <div class="text">
      5. 수집한 개인정보를 개인정보주체에 의해 공개하는 경우
    </div>
    <div class="text">
      6. 법률 뉴스 보도, 정부 정보 공개 및 기타 채널과 같이 법적으로 공개된 정보에서 수집한 귀하의 개인 정보
    </div>
    <div class="text">7. 귀하의 요청에 따라 계약을 체결하는 데 필요한 경우；</div>
    <div class="text">
      8. 재화 또는 용역의 고장을 찾아 처리하는 등 제공하는 재화 또는 용역의 안전하고 안정적인 운영을 위하여 필요한 경우；
    </div>
    <div class="text">9.적법한 보도를 위하여 필요한 경우；</div>
    <div class="text">
      10. 학술연구기관이 공익에 기초한 통계적 또는 학술적 연구를 수행하기 위하여 필요한 경우로서 학술연구 의 결과 또는 기술의 결과를 외부에 제공하는 경우 그 결과에 포함된 개인정보를 비식별화하는 경우
    </div>
    <div class="text">
	  귀하의 개인 정보는 모두 보안 서버에 저장되고 통제된 시설에서 보호됩니다. 중요도와 민감도에 따라 귀하의 데이터를 분류하고 귀하의 개인 정보에 대해 최고 수준의 보안을 보장합니다. 제품 및 서비스 제공을 돕기 위해 이 정보에 액세스하는 직원 및 제3자 서비스 제공업체 는 엄격한 계약상의 기밀 유지 의무가 있으며 이러한 의무를 준수하지 않을 경우 징계 조치 또는 해고를 초래할 수 있습니다. 마찬가지로 클라우드 기반 데이터 스토리지에 대한 특정 액세스 제어가 있습니다. 요약하면, 우리는 무단 액세스 및 사용을 방지하기 위해 물리적 보안 조치를 포함하여 정보 수집, 저장 및 처리 관행을 정기적으로 검토합니다.
    </div>
    <div class="subtitle">（五）당사가 제3자로부터 귀하의 개인 정보를 획득하는 상황</div>
    <div class="text">
      당사는 법률이 허용하는 경우 제3자로부터 귀하의 개인 정보를 얻을 수 있습니다.
    </div>
    <div class="subtitle">（六）비개인정보</div>
    <div class="text">
      또한, 이용자의 동작 행위(클릭, 페이지 점프, 브라우징 시간) . 이 정보를 수집하는 목적은 귀하에게 제공하는 서비스를 개선하는 것입니다. 수집되는 정보의 유형과 양은 귀하가 당사 제품 및/또는 서비스를 사용하는 방법에 따라 다릅니다. 당사는 이 정보를 집계하여 당사 웹사이트, 제품 및 서비스에서 고객이 가장 관심을 갖는 부분에 대한 보다 유용한 정보를 고객에게 제공할 수 있도록 합니다. 집계된 데이터는 이 개인정보 보호정책의 목적상 비개인 정보로 간주됩니다. 비개인 정보를 개인 정보와 함께 사용하는 경우 해당 정보는 조합 기간 동안 개인 정보로 간주됩니다.
    </div>
    <div class="numtitle">二、보존 정책</div>
    <div class="text">
      우리는 이 개인정보 보호정책에 설명된 대로 또는 해당 법률에서 요구하는 대로 정보가 수집된 목적을 위해 필요한 기간 동안 개인 정보를 보유합니다. 수집 목적을 달성한 후, 삭제 또는 해지 신청을 확인한 후 또는 해당 상품 또는 서비스의 운영을 종료한 후, 해당 정보의 보유를 중지하고 삭제 또는 익명화합니다. 공익, 과학적, 역사적 연구 또는 통계적 목적을 위한 경우 추가 데이터 처리가 원래 수집 목적과 관련이 없더라도 관련 법률에 따라 관련 데이터를 계속 보유합니다. 또한 다음과 같은 경우에는 관계법령에 따라 귀하의 개인정보를 보관해야 합니다.
    </div>
	<div class="text">
	  •중화인민공화국 전자상거래법에 따라 귀하의 상품 및 서비스 정보와 거래 정보는 거래 완료일로부터 3년 이상 보관해야 합니다 .
	</div>
    <div class="subtitle">三、귀하의 권리</div>
    <div class="numtitle">（一）제어 설정</div>
    <div class="text">
     우리는 모든 사람의 개인 정보 보호 문제가 다양하다는 것을 인정합니다. 따라서 우리는  ix cam 가 개인 정보의 수집, 사용, 공개 또는 처리를 제한하고 개인 정보 설정을 제어하기 위해 선택할 수 있는 다양한 방법의 몇 가지 예를 제공했습니다. 위치 액세스 켜기 또는 끄기: , 카메라, 녹음 및 휴대전화 저장 권한 읽기 및 쓰기；
    </div>
    <div class="subtitle">
      •  ix cam APP에서 "내 설정-개인 정보"를 클릭 하여 닉네임, 아바타 등의 개인 정보 를 수정 합니다 
    </div>
    <div class="text">• 금전 등록기 계정 로그인 또는 로그아웃</div>
    <div class="text">
      위의 목적으로 개인 정보를 사용하는 데 이전에 동의한 경우 언제든지 서면으로 또는 FAE@naxclow.com으로 연락하여 결정을 변경할 수 있습니다.
    </div>
    <div class="numtitle">（二）귀하의 개인 정보에 대한 귀하의 권리</div>
    <div class="text">
      해당 국가 또는 지역의 법률 및 규정에 따라 귀하는 당사가 귀하에 대해 보유하고 있는 모든 개인 정보에 대한 액세스, 수정 및 삭제를 요청할 권리 ( 이하 요청이라고 함)가 있습니다.
    </div>
    <div class="text">
      NAXA 계정의 개인 정보와 관련된 자세한 내용은 FAE@naxclow.com 또는 장치에서 계정에 로그인하여 액세스하고 변경할 수 있습니다 . 추가 정보를 원하시면 저희에게 편지를 보내시거나 FAE@naxclow.com을 방문하여 저희에게 연락해 주십시오. 대부분의 법률은 개인 정보 주체가 특정 요구 사항을 준수하도록 요청할 것을 요구하며 이 개인 정보 보호 정책에서는 다음 상황을 충족하도록 요청을 요구합니다.：
    </div>
    <div class="text">
      •
       당사의 전용 요청 채널을 통해 그리고 귀하의 정보 보호를 위해 귀하의 요청은 서면으로 이루어져야 합니다(현지 법률이 구두 요청을 명시적으로 인정하지 않는 한).
    </div>
    <div class="text">
      •
      요청자가 요청한 정보의 주체이거나 법적으로 승인된 사람인지 확인하기 위해 귀하의 신원을 확인할 수 있도록 충분한 정보를 제공하십시오.
    </div>
    <div class="text">
      •
      귀하의 요청을 처리할 수 있음을 확인할 수 있는 충분한 정보가 확보되면 해당 데이터 보호법에서 요구하는 시간 내에 귀하의 요청에 응답할 것입니다. 특히:
    </div>
    <div class="text">
      •
      귀하의 요청 및 관련 법률에 따라 당사는 귀하에 대해 수집 및 처리한 개인 정보의 무료 기록을 제공할 수 있습니다.
      귀하가 관련 정보에 대한 다른 요청을 하는 경우 당사는 관련 관련 법률 및 실제 관리 비용과 함께 합당한 수수료를 청구할 수 있습니다.
    </div>
    <div class="text">
      •
      당사가 보유하고 있는 귀하에 대한 정보가 부정확하거나 불완전하다고 생각되는 경우, 귀하는 사용 목적을 위해 개인 정보의 수정 또는 완성을 요청할 수 있습니다.
    </div>
    <div class="text">
      •
      개인 데이터 삭제 를 요청할 권리가 있을 수 있습니다 . 귀하의 삭제 요청을 검토하고 해당 규정이 충족되는 경우 기술적 수단을 포함하여 해당 조치를 취하여 처리합니다. 귀하 또는 당사가 관련 정보 삭제를 지원할 때 관련 법률 및 보안 기술로 인해 백업 시스템에서 해당 정보를 즉시 삭제하지 못할 수 있습니다. 당사는 귀하의 개인 정보를 안전하게 저장 하고 추가 처리로부터 격리할 것입니다. 백업을 지우거나 익명으로 할 수 있을 때까지. 예를 들어, 중화인민공화국 전자상거래법에 따라 귀하의 상품 및 서비스 정보와 거래 정보는 거래 완료일로부터 3년 이상 보관해야 합니다 .
    </div>
    <div class="text">
      •
      우리는 중요하지 않거나 얽힌 반복적인 요청, 타인의 개인 정보 보호 권리를 침해하는 요청, 극히 비현실적인 요청, 불균형한 기술 작업에 대한 요청, 현지 법률에 따라 요구되지 않는 요청, 공개된 정보의 처리를 거부할 권리가 있습니다. , 기밀 유지 조건에 따라 제공된 정보. 우리는 또한 앞서 언급한 사기 방지 및 보안 목적으로 데이터를 합법적으로 사용하는 것을 방해할 수 있다고 판단되는 특정 측면에서 데이터 삭제 또는 액세스 요청을 거부할 수 있습니다.
    </div>
    <div class="numtitle">（三）동의 철회</div>
    <div class="text">
      •
      귀하는 요청을 제출하여 당사가 소유하거나 통제하는 귀하의 개인 정보 수집, 사용 및/또는 공개를 포함한 동의를 철회할 수 있습니다. 사용하는 특정 서비스에 따라 "내" - "이용 계약 및 개인 정보 보호 정책"을 통해 앱 내에서 수행하거나 FAE@naxclow.com을 방문하여 문의할 수 있습니다. 당사는 귀하의 요청 후 15일 이내에 귀하의 요청을 처리할 것이며 귀하의 요청에 따라 그 이후에는 귀하의 개인 정보를 수집, 사용 및/또는 공개하지 않을 것입니다.
    </div>
    <div class="text">
      •
      동의 철회에는 특정한 법적 결과가 따른다는 점을 유의하십시오. 귀하가 당사에 처리하도록 승인한 정보의 범위에 따라 귀하는 당사 제품 또는 서비스를 즐길 수 없게 될 수 있습니다. 그러나 귀하의 동의 또는 승인 철회 결정은 귀하의 승인을 기반으로 한 이전 개인 정보 처리에 영향을 미치지 않습니다.
    </div>
    <div class="numtitle">（四）서비스 또는 계정의 해지</div>
    <div class="text">
      특정 제품이나 서비스를 취소하고자 하는 경우 FAE@naxclow.com을 방문하여 서비스 취소를 요청할 수 있습니다. 계정 을 해지할 경우 계정 의 전체 제품 및 서비스 를 사용할 수 없으므로 주의하여 운영하시기 바랍니다 . 당사는 귀하 또는 타인의 정당한 권리와 이익을 보호하기 위해 이 웹사이트의 다양한 제품 및 서비스 사용을 기반으로 귀하의 취소 요청에 대한 지원 여부를 판단합니다.
    </div>
    <div class="text">
      추신: "InnoMotion Smart Home" 앱의 "내" - "계정 보안" - 계정 해지를 통해 계정 해지 신청을 시작할 수 있습니다.
    </div>
    <div class="subtitle">四、귀하의 개인 정보 를 제3자 서비스 제공업체와 공유</div>
    <div class="text">
      이 사업의 일부 서비스는 제3자 서비스 제공업체에 의해 제공됩니다. 이러한 이유로 당사는 귀하의 개인정보 중 일부를 제3자 서비스 제공업체에 제공해야 합니다. 당사가 귀하의 개인정보를 이러한 제3자와 공유하는 경우, 당사는 귀하의 정보 보안을 보장하기 위해 암호화 및 기타 수단을 사용할 것입니다. 당사는 개인정보를 공유하는 기업 및 조직에 대해 데이터 보안 환경을 합리적으로 검토하고 엄격한 데이터 처리 계약을 체결하여 제3자에게 귀하의 정보에 대한 적절한 보호 조치를 취하고 관련 법률 및 규정을 엄격히 준수하도록 요구합니다. . 규제 요구 사항.
    </div>
    <div class="text">
      ix cam 앱의 관련 기능을 구현하고 애플리케이션의 안전하고 안정적인 작동을 보장하기 위해 당사는 관련 목적을 달성하기 위해 제3자 및 관련 당사자가 제공하는 소프트웨어 개발 키트(SDK)에 액세스할 수 있습니다. 데이터 보안을 보호하기 위해 파트너가 정보를 얻기 위해 사용하는 소프트웨어 도구 개발 키트(SDK)에 대해 엄격한 보안 모니터링을 수행합니다. 카탈로그에 연결된 관련 SDK 목록을 보려면 <a target="_blank" style="font-weight:bold;" href="#/sdk/sdk_file">"첨부 파일 - 타사 SDK 지침"</a>. 제3자 SDK 및 관련 당사자는 버전 업그레이드, 정책 조정 등으로 인해 데이터 처리 유형이 특정 변경될 수 있다는 점에 유의하세요. 게시된 공식 지침을 참조하세요.
    </div>
    <div class="subtitle">五、정책 업데이트</div>
    <div class="text">
      본 정책은 비즈니스 모델의 조정이나 업데이트에 따라 수시로 개정될 것이며, 그러한 개정은 본 개인정보 보호정책의 일부를 구성합니다.
    </div>
    <div class="text">
      귀하의 명확한 동의 없이, 우리는 귀하가 본 정책에 따라 향유하는 권리를 삭감하지 않을 것입니다.변경된 본 정책 조항이 귀하의 권리를 삭감하거나 귀하의 의무를 증가시키는 경우("중대한 변경"이 발생하는 경우), 저희는 ix cam 공식 사이트에 공시하고 적절한 방식(탄창 안내, 이메일, 문자 메시지 등 포함)으로 본 정책의 업데이트 상황을 알려드리며, 변경이 효력을 발생하기 전에 귀하와 개발자에게 합리적인 기한을 남겨 귀하가 변경을 수락할지 여부를 고려할 수 있도록 하겠습니다.
    </div>
    <div class="text">
      사용자가 업데이트된 본 정책에 동의하지 않을 경우 ix cam의 서비스 및 앱 사용을 중지할 수 있으며, 사용자가 업데이트된 본 정책이 발효된 후에도 ix cam의 서비스 및 앱을 계속 사용할 경우 사용자가 업데이트된 본 정책을 충분히 읽고 동의했음을 나타냅니다.
    </div>
    <div class="subtitle">六、문의하기</div>
    <div class="text">
      이 개인 정보 보호 정책에 대한 의견이나 질문이 있거나 개인 정보의 수집, 사용 또는 공개에 대해 질문이 있는 경우 아래 주소로 문의하거나 FAE@naxclow.com을 방문하여 "개인 정보 정책" . 개인정보에 관한 권리요구, 문의사항 등의 문제를 해결하기 위해 전문팀을 운영하고 있습니다. 귀하의 질문 자체가 더 중요한 문제와 관련된 경우 추가 정보를 요청할 수 있습니다. 귀하가 받은 응답이 만족스럽지 않다면 귀하의 불만 사항을 관할 관할권의 관련 감독 기관에 회부할 수 있습니다. 상담해 주시면 실제 상황에 따라 적용할 수 있는 관련 불만 사항에 대한 정보를 제공해 드리겠습니다.
    </div>
    <div class="text">
      이 개인 정보 보호 정책에 대한 의견이나 질문이 있거나 개인 정보의 수집, 사용 또는 공개에 대해 질문이 있는 경우 "개인 정보 보호 정책"을 참조하여 다음 주소로 데이터 보호 담당자에게 문의하십시오.：
    </div>
    <div class="text">
      광저우 체인링크 IoT Co., Ltd.
    </div>
    <div class="text">
    Huahui International, No.4 Zhudian Circuit, Nansha District , Guangzhou : FAE@naxclow.com
    </div>
    <div class="text">시간을 내어 개인정보 보호정책을 이해해주셔서 감사합니다!</div>
  </div>
</template>

<script type="text/javascript">
	import { mapState } from "vuex"
	export default {
		data() {
			return {};
		},
		created() {
			
		},
		methods: {},
		computed: {
			...mapState({
				tableData: "tableData"
			})
		}
	};
</script>

<style lang="less" scoped>
	.text-container {
		padding: 0 30px 50px;
		word-break:break-all;
		.title {
			font-size: 30px;
			margin: 15px 0;
			font-weight: 900;
		}

		.subtitle {
			font-size: 25px;
			margin: 10px 0;
			font-weight: 600;
		}

		.numtitle {
			font-size: 20px;
			margin: 10px 0;
			font-weight: 600;
		}
		.SDKTitle{
			  font-size: 20px;
			  margin: 15px 0;
			  text-align: center;
		}
		.headSDK{
			  background: rgb(145, 171, 225);
			  text-align: center;
			  display: flex;
			  // align-items: center;
		}
		.contSDK{
			  text-align: center;
			  display: flex;
		}
		th,td{
			  text-align: center;
			  padding: 3px 1px;
			  flex: 1;
			  display: flex;
			  justify-content: center;
			  align-items: center;
		}
	}
</style>
